<template>
  <Grid gtc="1fr 1fr 1fr" gtr="250px auto auto" gap="var(--r-space-sp) var(--r-space-md)" class="price">
    <Widgets :key="`widgets-${widgetsKey}`" />
    <PricesTable
      :key="`prices-table-${priceKey}`"
      :sub-id="id"
      class="prices-table"
      @period-updated="periodUpdated"
      @period-deleted="periodDeleted"
      @period-created="getSubscription"
    />
    <CostAllocation v-if="subscription" :sub-id="id" :periods="subscriptionPeriods" />
  </Grid>
</template>

<script>
import * as apiTo from '@/modular-api'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { event } from '@/plugins/event-bus'
// Components
import PricesTable from './components/prices-table/PricesTable'
import CostAllocation from './components/cost-allocation/CostAllocation'
import Widgets from './components/Widgets'

export default {
  components: {
    PricesTable,
    CostAllocation,
    Widgets
  },

  props: {
    id: [Number, String] // from route
  },

  data: () => ({
    widgetsKey: 0,
    priceKey: 0,
    shouldRefresh: false
  }),

  computed: {
    ...mapGetters('subscription-show', ['subscription', 'subscriptionPeriods'])
  },

  created() {
    event.$on('refreshPriceTab', () => (this.shouldRefresh = true))
    event.$on('refetchSubscriptionPeriods', () => this.refetchSubscriptionPeriods())
  },

  activated() {
    if (this.shouldRefresh) {
      this.priceKey++
      this.widgetsKey++
      this.shouldRefresh = false
    }
  },

  beforeDestroy() {
    event.$off('refreshPriceTab')
    event.$off('refetchSubscriptionPeriods')
  },

  methods: {
    ...mapMutations('subscription-show', [
      'setSubscriptionPeriods',
      'setSubscription',
      'setPeriodId',
      'updatePeriod',
      'deletePeriod'
    ]),
    ...mapActions('subscription-show', ['getAndSetSubscriptionPeriods']),

    periodUpdated(period) {
      this.widgetsKey++
      this.updatePeriod(period)
    },

    periodDeleted(id) {
      this.widgetsKey++
      this.deletePeriod(id)
      this.getSubscription()
    },

    getSubscription() {
      this.widgetsKey++
      apiTo.GET_SUBSCRIPTION(this.id).then(({ data }) => {
        this.setSubscription(data.result)
        const periodId = data.result.next ? data.result.next.id : data.result.current.id
        this.setPeriodId(periodId)
        this.$root.$emit('refresh-milestones-data', {
          periodId: periodId,
          milestone: null
        })
      })
    },

    async refetchSubscriptionPeriods() {
      await this.getAndSetSubscriptionPeriods(this.$route.params.id)
      this.widgetsKey++ // re-render widgets
    }
  }
}
</script>

<style lang="scss" scoped>
.price {
  > .widgets,
  > .prices-table {
    grid-column: span 3;
  }

  > .cost-allocation {
    grid-column: span 2;
  }
}
</style>
